// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakePatientModel {
    static getAttributeTypeMap() {
        return SimpleIntakePatientModel.attributeTypeMap;
    }
}
SimpleIntakePatientModel.discriminator = undefined;
SimpleIntakePatientModel.additionalProperties = false;
SimpleIntakePatientModel.attributeTypeMap = [
    {
        "name": "address",
        "baseName": "address",
        "type": "SimpleIntakeAddressModel"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "ethnicity",
        "baseName": "ethnicity",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "Gender"
    },
    {
        "name": "householdSize",
        "baseName": "householdSize",
        "type": "number"
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "isUsResident",
        "baseName": "isUsResident",
        "type": "boolean"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "phones",
        "baseName": "phones",
        "type": "SimpleIntakePatientPhonesModel"
    },
    {
        "name": "preferences",
        "baseName": "preferences",
        "type": "SimpleIntakePreferencesModel"
    },
    {
        "name": "primaryLanguageId",
        "baseName": "primaryLanguageId",
        "type": "number"
    },
    {
        "name": "race",
        "baseName": "race",
        "type": "string"
    },
    {
        "name": "ssn",
        "baseName": "ssn",
        "type": "string"
    },
];
//# sourceMappingURL=simpleIntakePatientModel.js.map